import {Box} from "@mui/material"
import React from "react"
import Content from "../../../components/Content"

const ContainerTableRow = ({row, widget, rowCount}) => {
    const renderWidget = _.cloneDeep(widget)
    if (widget.connections?.origin?.pointer) {
        renderWidget.connections.origin.pointer =
            renderWidget.connections?.origin.pointer.replace("[i]", rowCount)
        renderWidget.subtext =
            renderWidget.subtext?.replace("[i]", rowCount)
    }
    return (
        <Box 
            bgcolor={renderWidget.background && "#ddddff"}
            sx={{
                gridColumn: widget.x + 1 + " /span " + widget.w,
                gridRow: widget.y + rowCount + 1 + " /span " + widget.h,
            }}
        >
            <Content key={renderWidget.i} child={renderWidget} value={row[renderWidget.property]} payload={row} />
        </Box>
    )
}

export default ContainerTableRow
